import React from 'react';
import PropTypes from 'prop-types';

import { Select } from '@metarouter-private/mr-mui';
import WithTooltip from 'app/components/WithTooltip';

import { useBulkDeployPageContext } from 'ion-experimental/app/bulk-deploy/BulkDeployPageContext';

export default function IntegrationSelect({ disabled }) {
  const {
    selectedIntegration,
    integrationOptions,
    handleIntegrationChange,
    integrationSelectDisabled,
    integrationSelectDisabledMessage,
  } = useBulkDeployPageContext();

  const handleChange = ({ target }) => {
    handleIntegrationChange({ value: target.value });
  };

  const isDisabled = disabled || integrationSelectDisabled;

  return (
    <WithTooltip show={Boolean(integrationSelectDisabledMessage)} title={integrationSelectDisabledMessage}>
      <Select
        label="Integration"
        size="small"
        variant="outlined"
        value={selectedIntegration}
        options={integrationOptions}
        onChange={handleChange}
        disabled={isDisabled}
        data-test-id="integrationSelect"
      />
    </WithTooltip>
  );
}

IntegrationSelect.propTypes = {
  disabled: PropTypes.bool,
};
